enum MaxDecimals {
  Price = 2,
  TickSize = 1,
}

export default MaxDecimals;
